import { Box, Heading } from '@edreamsodigeo/prisma-design-system';
import React, { useState } from 'react';
import { Show, useTracking, useTranslation } from '@edreamsodigeo/frontend-core';
import { convertLegsToSections, isSectionWithDifferentPnr } from "../../../../utils";
import { modificationLCRoutes } from "../../../../types/routes";
import { useBookingAdminRouter, useDevice, useGetItineraryParams } from "../../../../clientState/hooks";
import { useSelectedFlights, useSelectedStopover } from "../../../../providers";
import { trackingEvents, trackLabelTypes } from "../../../../tracking/Modification/trackingEventsLC";
import FlightSelector from "../../../../components/common/ItinerarySelector/FlightSelector";
import { modificationEligibilityTypes } from "../../../../types/eligibilities";
import { BottomButtons, StopoverSelector } from "../../../../components/common";
const findIsChecked = isChecked => {
  return isChecked.findIndex(elem => elem === true);
};
const FlightSelectorLCSection = ({
  legs,
  isStopover,
  modifiable,
  onClickBack = () => {}
}) => {
  const {
    trackEvent
  } = useTracking();
  const {
    isMobile
  } = useDevice();
  const {
    navigateToWithToken
  } = useBookingAdminRouter();
  const {
    t
  } = useTranslation();
  const [isChecked] = useSelectedFlights();
  const [isCheckedStops] = useSelectedStopover();
  const itineraryParams = useGetItineraryParams();
  const indexChecked = isStopover ? findIsChecked(isCheckedStops) : findIsChecked(isChecked);
  const initDisabledButton = indexChecked < 0;
  const [isDisabledButton, setDisabledButton] = useState(initDisabledButton);
  const trackingContinueLC = () => {
    trackEvent(trackingEvents.CLICK_FLIGHT_SELECTOR(trackLabelTypes.continue));
  };
  const trackingSelectFlightLC = () => {
    trackEvent(trackingEvents.CLICK_FLIGHT_SELECTOR(isStopover ? trackLabelTypes.selectFlight : trackLabelTypes.selectFlightPNR));
  };
  const onClickContinue = () => {
    const leg = itineraryParams?.leg || 0;
    const withDifferentPNR = !isStopover && isSectionWithDifferentPnr(legs[indexChecked]);
    trackingContinueLC();
    if (isStopover) {
      navigateToWithToken(`${modificationLCRoutes.changeTripLC}/${leg}/${indexChecked}`);
    } else if (withDifferentPNR) {
      navigateToWithToken(`${modificationLCRoutes.yourStopOvers}/${indexChecked}`);
    } else {
      navigateToWithToken(`${modificationLCRoutes.changeTripLC}/${indexChecked}/0`);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    pb: ['big', '1x_big']
  }, /*#__PURE__*/React.createElement(Heading, {
    type: [5, 3],
    color: ['neutral.90', 'neutral.100'],
    weight: ['normal', 'medium']
  }, /*#__PURE__*/React.createElement(Box, {
    pb: ['base', 0]
  }, t('managebooking.modifytrip.changes.flightselector.heading.subtitle')), /*#__PURE__*/React.createElement(Show, {
    when: isMobile
  }, t('managebooking.modifytrip.change.flightselector.message')))), /*#__PURE__*/React.createElement(Box, {
    pb: ['1x_big', '2x_big']
  }, /*#__PURE__*/React.createElement(Show, {
    when: !isStopover
  }, /*#__PURE__*/React.createElement(FlightSelector, {
    legs: isStopover ? legs : convertLegsToSections(legs),
    typeModification: "change",
    processability: modifiable,
    genericEligibility: modificationEligibilityTypes.THIRD_PARTY,
    setDisabledButton: setDisabledButton,
    isStopover: isStopover,
    trackingOnChange: trackingSelectFlightLC
  })), /*#__PURE__*/React.createElement(Show, {
    when: isStopover
  }, /*#__PURE__*/React.createElement(StopoverSelector, {
    legs: isStopover ? legs : convertLegsToSections(legs),
    setDisabledButton: setDisabledButton,
    trackingOnChange: trackingSelectFlightLC
  }))), /*#__PURE__*/React.createElement(BottomButtons, {
    mainButtonText: t('managebooking.modifytrip.cancellations.flightselector.cta'),
    mainButtonClick: onClickContinue,
    isMainDisabled: isDisabledButton,
    leftButtonText: t('managebooking.cancel.flight.selector.page.cta.back'),
    leftButtonClick: onClickBack
  }));
};
export default FlightSelectorLCSection;